/** Default poll delay when `nextPollingIntervalMs` is absent or invalid. */
export const DEFAULT_EXPORT_POLLING_INTERVAL_MS = 5000;

/**
 * Derives the next poll delay from in-progress export rows using each row's
 * `nextPollingIntervalMs` (falling back to {@link DEFAULT_EXPORT_POLLING_INTERVAL_MS}).
 * Multiple exports: arithmetic mean of those values, rounded up (`Math.ceil`).
 */
export function resolveExportPollingIntervalMs(
  items: readonly { nextPollingIntervalMs?: number | null }[]
): number {
  if (items.length === 0) {
    return DEFAULT_EXPORT_POLLING_INTERVAL_MS;
  }

  const resolved = items.map((item) =>
    typeof item.nextPollingIntervalMs === 'number' &&
    Number.isFinite(item.nextPollingIntervalMs)
      ? item.nextPollingIntervalMs
      : DEFAULT_EXPORT_POLLING_INTERVAL_MS
  );

  const sum = resolved.reduce((acc, n) => acc + n, 0);

  return Math.ceil(sum / resolved.length);
}
